import React from 'react';
import {
  SendOutlined,
  InboxOutlined,
  UserOutlined,
  TeamOutlined,
  ApartmentOutlined,
  ShopOutlined,
  AppstoreOutlined,
} from '@ant-design/icons';

export interface MenuItemConfig {
  key: string;
  icon: React.ReactNode;
  label: string;
  children?: { key: string; label: string }[];
}

/** 一级菜单（从左到右顺序）及各自功能树节点 */
export const topMenuConfig: MenuItemConfig[] = [
  {
    key: '/shipments',
    icon: <SendOutlined />,
    label: '运单管理',
    children: [
      { key: '/shipments/list', label: '运单列表' },
      { key: '/shipments/handover', label: '待交货运单 - 操作员回填重量与凭证' },
    ],
  },
  {
    key: '/warehouse',
    icon: <InboxOutlined />,
    label: '货物管理',
    children: [
      { key: '/warehouse/cartons', label: '货物列表' },
    ],
  },
  {
    key: '/customers',
    icon: <UserOutlined />,
    label: '客户管理',
    children: [
      { key: '/customers/list', label: '客户列表' },
      { key: '/customers/addresses', label: '客户地址' },
      { key: '/customers/shipments', label: '客户运单' },
    ],
  },
  {
    key: '/routes',
    icon: <ApartmentOutlined />,
    label: '线路管理',
    children: [
      { key: '/routes/list', label: '线路列表' },
      { key: '/routes/channels', label: '渠道列表' },
    ],
  },
  {
    key: '/agents',
    icon: <TeamOutlined />,
    label: '代理管理',
    children: [
      { key: '/agents/list', label: '代理列表' },
      { key: '/agents/depots', label: '代理仓库列表' },
      { key: '/agents/services', label: '代理渠道列表' },
    ],
  },
  {
    key: '/suppliers',
    icon: <ShopOutlined />,
    label: '供应商管理',
    children: [
      { key: '/suppliers/list', label: '供应商列表' },
    ],
  },
  {
    key: '/products',
    icon: <AppstoreOutlined />,
    label: '产品管理',
    children: [
      { key: '/products/list', label: '产品列表' },
    ],
  },
];
